import React, { Component } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Calendar, Clock, MapPin, Users, Tag, Heart } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
import { WorkshopCard } from '../components/WorkshopCard';
import { QuoteCard } from '../components/QuoteCard';
import { stories } from '../data/stories';
export function MaekerscafeDetail() {
  const {
    slug
  } = useParams();
  // Mock data for current maekerscafé
  const cafe = {
    slug,
    name: 'Maekerscafé Draad',
    theme: 'Draad',
    tagline: 'Voor liefhebbers van macramé, weven en andere draadtechnieken',
    description: 'Maekerscafé Draad is dé plek voor iedereen die graag met draad, touw en textiel werkt. Of je nu aan macramé doet, weeft, knoopt of experimenteert met nieuwe technieken — hier vind je gelijkgestemden om samen aan de slag te gaan.',
    whatToExpect: 'Tijdens het maekerscafé werk je aan je eigen project in een gezellige, informele sfeer. Er is geen vaste agenda of lesgever — het draait om samen werken, kennis delen en inspiratie opdoen. Ervaren makers helpen beginners graag op weg, en je kunt altijd terecht met vragen over materialen, technieken of patronen.',
    whatToBring: 'Breng je eigen project en materialen mee. Basisgereedschap (scharen, meetlinten, naalden) is aanwezig. Heb je nog geen project? Geen probleem — er liggen altijd restmaterialen klaar om mee te experimenteren.',
    frequency: 'Elke tweede en vierde dinsdagavond van de maand',
    time: '19:30 – 21:30',
    location: 'De Maekerij, Louis Melsensstraat 17, 3000 Leuven',
    cost: 'Gratis — je betaalt enkel een drankje aan de bar',
    upcomingDates: [{
      date: 'di 11 feb 2026',
      time: '19:30 – 21:30'
    }, {
      date: 'di 25 feb 2026',
      time: '19:30 – 21:30'
    }, {
      date: 'di 11 mrt 2026',
      time: '19:30 – 21:30'
    }, {
      date: 'di 25 mrt 2026',
      time: '19:30 – 21:30'
    }]
  };
  const relatedWorkshops = [{
    id: '3',
    title: '2D naaldvilten in borduurring',
    date: 'di 10 feb 2026',
    time: '19:00 t/m 21:30',
    theme: 'Draad'
  }, {
    id: '11',
    title: 'Macramé voor beginners',
    date: 'za 15 feb 2026',
    time: '14:00 t/m 16:30',
    theme: 'Draad'
  }, {
    id: '12',
    title: 'Weven met natuurlijke materialen',
    date: 'za 22 feb 2026',
    time: '10:00 t/m 13:00',
    theme: 'Draad'
  }];
  return <div className="container mx-auto px-4 py-10" data-id="element-885">
      {/* Back link */}
      <div className="mb-6" data-id="element-886">
        <Link to="/maekerscafés" className="text-gray-600 hover:underline inline-flex items-center group" data-id="element-887">
          <ArrowLeft size={16} className="mr-1 group-hover:-translate-x-1 transition-transform duration-200" data-id="element-888" />
          Terug naar maekerscafés
        </Link>
      </div>

      {/* Hero image */}
      <div className="border-2 border-dashed border-gray-300 h-64 md:h-80 flex items-center justify-center bg-gray-100 rounded-lg mb-8" data-id="element-889">
        <span className="text-gray-400" data-id="element-890">{cafe.name} sfeerbeeld</span>
      </div>

      {/* Title + theme */}
      <div className="mb-6" data-id="element-891">
        <div className="flex items-center gap-3 mb-2" data-id="element-892">
          <span className="inline-flex items-center px-3 py-1 bg-gray-100 rounded-full text-sm" data-id="element-893">
            <Tag size={14} className="mr-1" data-id="element-894" />
            {cafe.theme}
          </span>
          <span className="inline-flex items-center px-3 py-1 bg-gray-100 rounded-full text-sm text-green-700" data-id="element-895">
            <Heart size={14} className="mr-1" data-id="element-896" />
            Gratis
          </span>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-897">{cafe.name}</h1>
        <p className="text-lg text-gray-500" data-id="element-898">{cafe.tagline}</p>
      </div>

      {/* Key info bar */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10 p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-899">
        <div className="flex items-center" data-id="element-900">
          <Calendar size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-901" />
          <div data-id="element-902">
            <p className="text-xs text-gray-500" data-id="element-903">Wanneer</p>
            <p className="text-sm font-medium" data-id="element-904">{cafe.frequency}</p>
          </div>
        </div>
        <div className="flex items-center" data-id="element-905">
          <Clock size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-906" />
          <div data-id="element-907">
            <p className="text-xs text-gray-500" data-id="element-908">Tijdstip</p>
            <p className="text-sm font-medium" data-id="element-909">{cafe.time}</p>
          </div>
        </div>
        <div className="flex items-center" data-id="element-910">
          <MapPin size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-911" />
          <div data-id="element-912">
            <p className="text-xs text-gray-500" data-id="element-913">Locatie</p>
            <p className="text-sm font-medium" data-id="element-914">De Maekerij</p>
          </div>
        </div>
        <div className="flex items-center" data-id="element-915">
          <Users size={18} className="mr-2 text-gray-500 flex-shrink-0" data-id="element-916" />
          <div data-id="element-917">
            <p className="text-xs text-gray-500" data-id="element-918">Kosten</p>
            <p className="text-sm font-medium" data-id="element-919">Gratis</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-920">
        {/* Main content */}
        <div className="lg:col-span-2" data-id="element-921">
          {/* Description */}
          <section className="mb-8" data-id="element-922">
            <h2 className="text-xl font-bold mb-3" data-id="element-923">Over dit maekerscafé</h2>
            <p className="text-gray-600 leading-relaxed mb-4" data-id="element-924">
              {cafe.description}
            </p>
          </section>

          {/* What to expect */}
          <section className="mb-8" data-id="element-925">
            <h2 className="text-xl font-bold mb-3" data-id="element-926">Wat kun je verwachten?</h2>
            <p className="text-gray-600 leading-relaxed" data-id="element-927">{cafe.whatToExpect}</p>
          </section>

          {/* What to bring */}
          <section className="mb-8" data-id="element-928">
            <h2 className="text-xl font-bold mb-3" data-id="element-929">Wat meenemen?</h2>
            <p className="text-gray-600 leading-relaxed" data-id="element-930">{cafe.whatToBring}</p>
          </section>

          {/* Photo gallery placeholder */}
          <section className="mb-8" data-id="element-931">
            <h2 className="text-xl font-bold mb-3" data-id="element-932">Sfeerbeelden</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-933">
              <div className="border-2 border-dashed border-gray-300 h-32 flex items-center justify-center bg-gray-100 rounded" data-id="element-934">
                <span className="text-gray-400 text-xs" data-id="element-935">Foto 1</span>
              </div>
              <div className="border-2 border-dashed border-gray-300 h-32 flex items-center justify-center bg-gray-100 rounded" data-id="element-936">
                <span className="text-gray-400 text-xs" data-id="element-937">Foto 2</span>
              </div>
              <div className="border-2 border-dashed border-gray-300 h-32 flex items-center justify-center bg-gray-100 rounded" data-id="element-938">
                <span className="text-gray-400 text-xs" data-id="element-939">Foto 3</span>
              </div>
            </div>
          </section>

          {/* Community quote */}
          <section className="mb-8" data-id="element-940">
            <h2 className="text-xl font-bold mb-4" data-id="element-941">Uit de community</h2>
            <QuoteCard story={stories.filter(s => s.category === 'maekerscafe')[0]} data-id="element-942" />
          </section>
        </div>

        {/* Sidebar */}
        <div data-id="element-943">
          {/* Upcoming dates */}
          <div className="mb-6" data-id="element-944">
            <h3 className="text-lg font-bold mb-3" data-id="element-945">Komende data</h3>
            <Card variant="outlined" data-id="element-946">
              <CardContent data-id="element-947">
                <ul className="divide-y divide-gray-200" data-id="element-948">
                  {cafe.upcomingDates.map((item, i) => <li key={i} className="py-3 first:pt-0 last:pb-0" data-id="element-949">
                      <div className="flex items-center justify-between mb-1" data-id="element-950">
                        <span className="text-sm font-medium" data-id="element-951">{item.date}</span>
                      </div>
                      <span className="text-xs text-gray-500" data-id="element-952">{item.time}</span>
                    </li>)}
                </ul>
                <div className="mt-4" data-id="element-953">
                  <Link to="/workshops?type=maekerscafe" data-id="element-954">
                    <Button variant="primary" size="medium" className="w-full" data-id="element-955">
                      Bekijk in kalender
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Practical info */}
          <div className="mb-6" data-id="element-956">
            <h3 className="text-lg font-bold mb-3" data-id="element-957">Praktisch</h3>
            <Card variant="outlined" data-id="element-958">
              <CardContent className="divide-y divide-gray-200" data-id="element-959">
                <div className="py-3 first:pt-0" data-id="element-960">
                  <h4 className="font-medium mb-1 text-sm" data-id="element-961">Locatie</h4>
                  <p className="text-sm text-gray-600" data-id="element-962">{cafe.location}</p>
                </div>
                <div className="py-3" data-id="element-963">
                  <h4 className="font-medium mb-1 text-sm" data-id="element-964">Kosten</h4>
                  <p className="text-sm text-gray-600" data-id="element-965">{cafe.cost}</p>
                </div>
                <div className="py-3" data-id="element-966">
                  <h4 className="font-medium mb-1 text-sm" data-id="element-967">Aanmelden</h4>
                  <p className="text-sm text-gray-600" data-id="element-968">
                    Niet verplicht, maar wel handig zodat we weten hoeveel
                    mensen er komen.
                  </p>
                </div>
                <div className="py-3 last:pb-0" data-id="element-969">
                  <h4 className="font-medium mb-1 text-sm" data-id="element-970">Sfeer</h4>
                  <p className="text-sm text-gray-600" data-id="element-971">
                    Informeel — kom en ga wanneer je wilt. Geen vaste agenda.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Join CTA */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-5 text-center" data-id="element-972">
            <p className="text-sm text-gray-600 mb-3" data-id="element-973">
              Vragen over dit maekerscafé?
            </p>
            <Link to="/contact" data-id="element-974">
              <Button variant="secondary" size="medium" className="w-full" data-id="element-975">
                Neem contact op
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Related workshops */}
      <div className="mt-16" data-id="element-976">
        <div className="flex items-center justify-between mb-6" data-id="element-977">
          <div data-id="element-978">
            <h2 className="text-2xl font-bold mb-2" data-id="element-979">
              Workshops binnen thema {cafe.theme}
            </h2>
            <p className="text-gray-500" data-id="element-980">
              Wil je je vaardigheden verder ontwikkelen? Bekijk onze workshops
              rond hetzelfde thema.
            </p>
          </div>
          <Link to={`/workshops?theme=${encodeURIComponent(cafe.theme)}`} data-id="element-981">
            <Button variant="secondary" size="medium" rightIcon={<ArrowRight size={16} data-id="element-983" />} data-id="element-982">
              Meer workshops binnen thema
            </Button>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-984">
          {relatedWorkshops.map(workshop => <WorkshopCard key={workshop.id} {...workshop} data-id="element-985" />)}
        </div>
      </div>
    </div>;
}